import { extendTheme } from "@chakra-ui/react"
import { Modal } from './modal';
import { global } from './global';
import { Button } from './button';
import { Tag } from './tag';
import { List } from './list';
import { Link } from './link';
import { Text, Heading } from './text';
import { Menu } from './menu';
import { FormLabel, Select, Input, Textarea } from './form';
import { Avatar } from './avatar';
import { layerStyles } from "./layer-styles";
import { colors } from "./base";

export const theme = extendTheme({
  styles: {
    global,
  },
  colors,
  layerStyles,
  components: {
    Modal,
    Menu,
    Avatar,
    FormLabel,
    Select,
    Input,
    Tag,
    Button,
    Text,
    Textarea,
    Heading,
    List,
    Link,
  },
});
